import SessionEventProto from "../session-event-proto"
import {BUS_SAVED_VIEW_UPDATE} from "../../model2/saved-view/@const";

export default class SessionSavedViewDelta extends SessionEventProto {

    private header : {
        savedView       :   any
    }

    constructor(sessionEvent: any) {
        super(sessionEvent)
        this.method     = sessionEvent.method
        this.header     = {
            savedView   : sessionEvent.savedView,
        }
        this.fromSID    = sessionEvent.fromSID
    }

    process() {
        if (this.isDifferentCompany()) return false

        gd.modelBus.newUpdate(BUS_SAVED_VIEW_UPDATE, this.method, this.header.savedView.id, this.data, this.header);
    }
}
